var map = {
	"./feroce1.jpg": 5165,
	"./feroce2.jpg": 6655,
	"./feroce3.jpg": 8197,
	"./feroce4.jpg": 6423,
	"./feroce5.jpg": 1629,
	"./feroce6.jpg": 1239,
	"assets/fashionStyling/editorials/feroce-magazine/feroce1.jpg": 5165,
	"assets/fashionStyling/editorials/feroce-magazine/feroce2.jpg": 6655,
	"assets/fashionStyling/editorials/feroce-magazine/feroce3.jpg": 8197,
	"assets/fashionStyling/editorials/feroce-magazine/feroce4.jpg": 6423,
	"assets/fashionStyling/editorials/feroce-magazine/feroce5.jpg": 1629,
	"assets/fashionStyling/editorials/feroce-magazine/feroce6.jpg": 1239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9700;